// import api from '../utils/api'
import axios from 'axios'
export default {
  asynct (context) {
    setTimeout(() => {
      context.commit('bag')
    }, 1000)
  },
  async lists (context) {
    const res = await axios.get('post_search', {
      params: {

      }
    }, context.state.list)
    console.log(res)

    // axios.get('post_search', context.state.list)
    //   .then(function (res) {
    //     console.log(res)
    //   })
    //   .catch(function (err) {
    //     console.log(err)
    //   })
  }

}
